var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #006b87;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,0c2.1,0,4.2.4,6.2,1.3,3.8,1.6,6.9,4.7,8.5,8.5,1.7,4,1.7,8.5,0,12.4-.8,1.9-2,3.6-3.4,5.1-1.5,1.4-3.2,2.6-5.1,3.4-4,1.7-8.5,1.7-12.4,0-3.8-1.6-6.9-4.7-8.5-8.5-1.7-4-1.7-8.5,0-12.4.8-1.9,2-3.6,3.4-5.1,1.5-1.5,3.2-2.6,5.1-3.4C11.7.4,13.9,0,16,0ZM16,1.9c-7.8,0-14,6.3-14,14.1,0,7.8,6.3,14,14.1,14,7.8,0,14-6.3,14-14.1,0-3.7-1.5-7.3-4.1-9.9-2.6-2.7-6.2-4.2-10-4.1h0ZM13.4,25.6l11.2-14.6-18.2,2.4,2.7,4.7,11.3-4.7-9.7,7.4,2.7,4.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/Icon_Send.0e075707a9b17d414a76010855cd442e.svg";
export { ForwardRef as ReactComponent };